import { MASK_EMAIL, MASK_SMS } from '../validators/regex';
import { PLUS_ONE_COUNTRY_CODE } from '../../constants/common.constants';

/**
 * Masks a phone number by hiding the first six digits (e.g., "+17759865200" → "xxx-xxx-5200").
 * @param phone The phone number to mask.
 * @returns Masked phone number in "xxx-xxx-5200" format.
 */
export const maskPhoneNumber = (phone: string) => {
    if (!phone) return phone;
    const sanitizedPhone = phone.startsWith(PLUS_ONE_COUNTRY_CODE) ? phone.slice(2) : phone;
    return sanitizedPhone.replace(MASK_SMS, 'xxx-xxx-$3');
};

/**
 * Masks an email address by replacing the characters between the first character
 * and the domain with asterisks.
 *
 * @param email - The email address to be masked. If the input is falsy, it will be returned as is.
 * @returns The masked email address, or the original input if it is falsy.
 *
 */
export const maskEmail = (email: string) => {
    if (!email) return email;
    return email.replace(MASK_EMAIL, (_, first, __, domain) => `${first}******${domain}`);
};

export const MASK_TIMEOUT = 15 * 1000;

export const maskValue = (value = '') => {
    if (!value) return value; 
    const str = String(value);
    if (str.length <= 4) return str;

    const lastFour = str.slice(-4);
    const masked = str
        .slice(0, -4)
        .replace(/[^\W_]/g, '*'); // Replace letters/digits but not special characters

    return masked + lastFour;
};